import { TEMPLATES_ENDPOINT } from "../config";
import { createInstance } from "./createInstance";
const instance = createInstance(TEMPLATES_ENDPOINT);
export default instance;
